import React from 'react';
import classNames from 'classnames/bind';
import { LuUserCircle, LuMail, LuBuilding2, LuShieldCheck, LuBadge, LuTrash2 } from 'react-icons/lu';

import styles from './Account.module.scss';

const cx = classNames.bind(styles);

function UserGrid({ isLoading, filteredUsers, onDeleteUser, deletingUserId }) {
    if (isLoading) {
        return <div className={cx('loading-state')}>Đang tải danh sách người dùng...</div>;
    }

    if (!filteredUsers.length) {
        return (
            <div className={cx('empty-state')}>
                <h3>Không có người dùng phù hợp</h3>
                <p>Hãy điều chỉnh từ khóa tìm kiếm hoặc kiểm tra lại.</p>
            </div>
        );
    }

    return (
        <div className={cx('user-grid')}>
            {filteredUsers.map((user) => {
                const departmentLabel = user.departmentName || user.department || 'Chưa gán phòng ban';
                const positionLabel = user.positionName || user.position || 'Chưa gán chức vụ';
                const emailLabel = user.email || 'Chưa cập nhật';
                const isDeleting = deletingUserId === user._id;

                const handleDeleteClick = () => {
                    if (onDeleteUser) {
                        onDeleteUser(user._id);
                    }
                };

                return (
                    <article key={user._id} className={cx('user-card')}>
                        <div className={cx('user-card__avatar')}>
                            <LuUserCircle />
                        </div>
                        <div className={cx('user-card__body')}>
                            <header className={cx('user-card__header')}>
                                <div className={cx('user-card__title')}>
                                    <h2>{user.fullname || 'Chưa cập nhật'}</h2>
                                    <span className={cx('user-card__username')}>
                                        <LuBadge />
                                        {user.username}
                                    </span>
                                </div>
                                {onDeleteUser && (
                                    <button
                                        type="button"
                                        className={cx('user-card__delete-button')}
                                        onClick={handleDeleteClick}
                                        disabled={isDeleting}
                                    >
                                        <LuTrash2 className={cx('user-card__delete-icon', { spinning: isDeleting })} />
                                        {isDeleting ? 'Đang xóa...' : 'Xóa'}
                                    </button>
                                )}
                            </header>
                            <div className={cx('user-card__info')}>
                                <div className={cx('info-row')}>
                                    <LuMail />
                                    <span>{emailLabel}</span>
                                </div>
                                <div className={cx('info-row')}>
                                    <LuBuilding2 />
                                    <span>{departmentLabel}</span>
                                </div>
                                <div className={cx('info-row')}>
                                    <LuShieldCheck />
                                    <span>{positionLabel}</span>
                                </div>
                            </div>
                        </div>
                    </article>
                );
            })}
        </div>
    );
}

export default UserGrid;
